import PropTypes from 'prop-types';

import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';
import { default as styles } from '../../../scss/components/Card.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

interface EyebrowHeaderProps {
  children: React.ReactNode;
}

const EyebrowHeader = ({ children }: EyebrowHeaderProps) => (
  <h5 className={withCssModulesClassNamesHandler('card__eyebrow-header')}>{children}</h5>
);

EyebrowHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default EyebrowHeader;
